export default `
  mutation GET_CUSTOMER_GROUP_ID_MUTATION ($cartId: String!) {
    getCustomerGroupId(
      input: {
        cartId: $cartId
        }
      ) {
      groupId
      success
      message
    }
}
`;
